$(function () {
  $("[data-behavior=vertical-center]").exists(function ($containers) {
    var resetContainer = function(container) {  
      var date = new Date();
      var heights = $("> *", $(container)).map(function (index, col) {
        return $(col).outerHeight();
      }).get(); // need to call get() on this to ensure this is a real array. otherwise phantom.js will fail...
      $(container).height(Math.max.apply(null, heights));
    };

    var updateContainers = function() {
      $containers.each(function(i, container) {
        var date = new Date();
        setTimeout(resetContainer, 500, container);
      });
    };


    $(window).on('resize', function(event) {
      updateContainers();
    }); 

    updateContainers();

    
  });
});
